<template>
  <v-container grid-list-md>
  <utility-backButton/>
  <v-layout row wrap justify-center>
    <v-flex x12>
      <div>
        <v-card-title class="title">
          Do timesheet for:
        </v-card-title>
        <v-flex xs8 class="text-xs-center">
        <v-progress-circular color="blueBackground" indeterminate v-show="loadingManagers"></v-progress-circular>
      </v-flex>
        <div class="text-xs-center">
            <v-checkbox v-model="active_checked" :label="`Filter Inactive Users`" id="active-filter" />
        </div>
        <v-list two-line>
          <template v-for="(user, index) in submissionUsers">
            <v-list-tile
              :key="`${index}:list`"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{user.GivenName}} {{user.Surname}}</v-list-tile-title>
                <v-list-tile-sub-title>{{user.EmailAddress}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn right small color="pipefishGreen" @click="visitTimesheet(user)">
                  visit Timesheet
                  <v-icon right>mdi-calendar-clock</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider
              :key="index"
            >
            </v-divider>
          </template>
        </v-list>
      </div>

    </v-flex>

  </v-layout>
</v-container>
</template>

<script>
import {
  mapState,
  mapActions
} from 'vuex'

export default {
  data: () => ({
    active_checked: true,
    submissionUsers: [],
    loadingManagers: true
  }),
  computed: {
    ...mapState('admin', ['pipefishUsers']),
  },
  created() {
    var self = this
    if(this.pipefishUsers.length == 0) {
      this.$timesheetApi.getAllUsers().then(users => {
        self.setSortedPipefishUsers(users);
        self.submissionUsers = self.pipefishUsers;  
        this.active_checked ? self.filterTimesheets(true) : false;
        this.loadingManagers = false;
      } )
    } else {
      this.submissionUsers = this.pipefishUsers;
      this.active_checked ? self.filterTimesheets(true) : false;
      this.loadingManagers = false;
    }
    
  },
  methods: {
    ...mapActions('admin', ['setSortedPipefishUsers']),
    visitTimesheet(user) {
      this.$router.push({
        name: 'Timesheets',
        params: {
          userId: {
            id: user.id,
            name: `${user.GivenName} ${user.Surname}`
          }
        }
      })
    },
    filterTimesheets(n) {
        var self = this;
        var temp = this.submissionUsers;
        if(this.active_checked) {
            temp = temp.filter(obj => {
            return n ? obj.IsActive : true;
            })
        }
        this.submissionUsers = n ? temp : this.pipefishUsers;
    }
  },
  watch: {
    active_checked: function(n, o) {
        console.log('CHANGED' + n + ' | ' + o);
      this.filterTimesheets(n);
    }
  }
}
</script>

<style>

</style>
